import PropTypes from 'prop-types';

import IconComponent from 'Component/Icon';

/** @namespace Bodypwa/Component/DeliveryFastIcon/Component */
export class DeliveryFastIconComponent extends IconComponent {
    static propTypes = {
        size: PropTypes.string.isRequired,
        color: PropTypes.string.isRequired
    };

    render() {
        const { dimensions, colors } = this;
        const { size, color } = this.props;
        return (
            <svg
              width={ dimensions[ size ] }
              height={ dimensions[ size ] }
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M3 3.00049H17.5556V5.22271H19.1656L22
            8.41138V19.166H20.2831C19.8446 20.2414 18.7886 20.9993 17.5556 20.9993C16.3225 20.9993
            15.2665 20.2414 14.828 19.166H9.17203C8.73351 20.2414 7.67749 20.9993 6.44445 20.9993C5.21141
            20.9993 4.1554 20.2414 3.71687 19.166H2V16.9438H3.71867C3.85828 16.6027 4.5 15.1104 6.44445
            15.1104C7.67751 15.1104 8.73354 15.8684 9.17206 16.9438H14.828C14.951 16.642 15.1227 16.3652
            15.3333 16.1231V5.22271H3V3.00049ZM17.5556 15.1104C17.2863 15.1104 17.0255 15.1466 16.7778
            15.2143V7.44493H18.1677L19.7778 9.25627V16.1231C19.238 15.5027 18.4426 15.1104 17.5556
            15.1104ZM4.94445 18.0549C4.94445 17.2265 5.61602 16.5549 6.44445 16.5549C7.27288 16.5549 7.94445
            17.2265 7.94445 18.0549C7.94445 18.8833 7.27288 19.5549 6.44445 19.5549C5.61602 19.5549 4.94445
            18.8833 4.94445 18.0549ZM17.5556 16.5549C16.7271 16.5549 16.0556 17.2265 16.0556 18.0549C16.0556
            18.8833 16.7271 19.5549 17.5556 19.5549C18.384 19.5549 19.0556 18.8833 19.0556 18.0549C19.0556
            17.2265 18.384 16.5549 17.5556 16.5549Z"
            fill={ colors[ color ] }
            className="icon-color"
          />
          <path d="M9 13.0005H2V11.5005H9V13.0005Z" fill={ colors[ color ] } className="icon-color" />
          <path d="M4 9.00049H11V7.50049H4V9.00049Z" fill={ colors[ color ] } className="icon-color" />
            </svg>

        );
    }
}
export default DeliveryFastIconComponent;
